class HHHeaderSubmenu extends HTMLElement {
  static properties = {
    _open: {
      state: false,
    },
  }

  constructor() {
    super()

    this.toggle = this.toggle.bind(this)
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)
    this.handleOutsideEvent = this.handleOutsideEvent.bind(this)
    this.keydown = this.keydown.bind(this)
    this.isTransitioning = false
  }

  connectedCallback() {
    this.$parent = this.querySelector('hh-animate-on-display')
    if (!this.$parent) {
      this.$parent = this.closest('hh-animate-on-display')
    }

    this.anchorEl = this.querySelector('.js-submenu-anchor')
    this.menuEl = this.querySelector(this.$parent.dataset.target)
    this.mobileBack = this.querySelector('.js-submenu-back')
    this.submenuItems = this.querySelectorAll('.js-submenu-item')
    this.header = document.querySelector('.js-header-wrapper')
    this.hasStickyHeader = !!document.querySelector('hh-sticky-header')

    this.anchorEl?.addEventListener('click', this.toggle)
    this.anchorEl?.addEventListener('keydown', this.keydown)
    this.mobileBack?.addEventListener('click', this.close)

    document.addEventListener('focusin', this.handleOutsideEvent)
  }

  disconnectedCallback() {
    this.anchorEl?.removeEventListener('click', this.toggle)
    this.anchorEl?.removeEventListener('keydown', this.keydown)
    this.mobileBack?.removeEventListener('click', this.close)

    document.removeEventListener('focusin', this.handleOutsideEvent)
    if (this.openTimeout) {
      clearTimeout(this.openTimeout)
    }
  }

  keydown(e) {
    if (e.code.toUpperCase() === 'ESCAPE' || e.code.toUpperCase() === 'ENTER') {
      e.preventDefault()
      this.anchorEl.click()
    }
  }

  toggle(e) {
    e.preventDefault()
    e.stopPropagation()

    if (this.isTransitioning) return

    this.isTransitioning = true

    setTimeout(() => {
      this._open ? this.close() : this.open()
      setTimeout(() => {
        this.isTransitioning = false
      }, 300)
    }, 10)
  }

  open() {
    if (this.openTimeout) {
      clearTimeout(this.openTimeout)
    }

    if (this._open) return

    this._open = true
    this.menuEl.setAttribute('aria-hidden', 'false')
    this.anchorEl.setAttribute('aria-expanded', 'true')

    this.openTimeout = setTimeout(() => {
      if (this._open) {
        this.menuEl.classList.remove('submenu--hidden')
      }
    }, 0)

    if (!this.hasStickyHeader && this.header.classList.contains('is-transparent')) {
      this.header.classList.remove('is-transparent')
    }

    document.querySelector('.js-overlay').classList.add('active')
    document.querySelector('body').classList.add('header-submenu-is-active')
    // document.querySelector('html').classList.add('scroll-lock')
  }

  close() {
    if (this.openTimeout) {
      clearTimeout(this.openTimeout)
      this.openTimeout = null
    }

    if (!this._open) return

    this.menuEl.classList.add('submenu--hidden')
    this.menuEl.setAttribute('aria-hidden', 'true')
    this.anchorEl.setAttribute('aria-expanded', 'false')
    this._open = false
    document.querySelector('.js-overlay').classList.remove('active')
    document.querySelector('body').classList.remove('header-submenu-is-active')

    if (this.hasStickyHeader && (this.header.dataset.page === 'index' || this.header.dataset.page == '404')) {
      const scrollPos = window.pageYOffset || document.documentElement.scrollTop
      this.header.classList[scrollPos === 0 ? 'add' : 'remove']('is-transparent')
    }
  }

  handleOutsideEvent(e) {
    if (this.isTransitioning || this.contains(e.target)) {
      return
    }

    if (this._open) {
      this.close()
    }
  }
}

customElements.define('hh-header-submenu', HHHeaderSubmenu)
